import TokenHandler from "./base";
import { API_HOST } from "../config";
import axios from "axios";
import { IService, IPaginationModal } from "types/App";

interface IApiKeyService extends IService {
  generateToken: () => Promise<any>;
}

async function fetchAll(paginationModel: IPaginationModal = {}) {
  const token = TokenHandler.getToken();
  const filteredPagination = { ...paginationModel };
  delete filteredPagination.query;
  delete filteredPagination.sort;

  const url = new URL(`${API_HOST}/api-keys`);
  url.search = new URLSearchParams(filteredPagination).toString();

  const response = await axios.get(url.toString(), {
    params: { query: paginationModel.query, sort: paginationModel.sort },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

async function fetch(id: string) {
  const token = TokenHandler.getToken();
  const response = await axios.get(`${API_HOST}/api-keys/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

async function create(data: any) {
  const token = TokenHandler.getToken();
  const response = await axios.post(`${API_HOST}/api-keys`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

async function update(id: string, data: any) {
  const token = TokenHandler.getToken();
  const response = await axios.put(`${API_HOST}/api-keys/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

async function remove(id: string) {
  const token = TokenHandler.getToken();
  const response = await axios.delete(`${API_HOST}/api-keys/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

async function generateToken() {
  const token = TokenHandler.getToken();
  const response = await axios.get(`${API_HOST}/api-keys/generate-token`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

const apiKeysService: IApiKeyService = {
  fetch,
  fetchAll,
  create,
  update,
  remove,
  generateToken,
};

export default apiKeysService;
